/**
* LoginController
* @namespace gplans.authentication.controllers
*/
(function () {
  'use strict';LoginController.$inject = ["$state", "$rootScope", "$scope", "Authentication"];

  angular.
  module('gplans.authentication.controllers').
  controller('LoginController', LoginController);

  LoginController.$inject = ['$state', '$rootScope', '$scope', 'Authentication'];

  /**
                                                                                  * @namespace LoginController
                                                                                  */
  function LoginController($state, $rootScope, $scope, Authentication) {
    var vm = this;

    vm.login = login;
    vm.fbLogin = fbLogin;
    vm.errMessage = '';
    vm.loading = false;

    activate();

    /**
                * @name activate
                * @desc Actions to be performed when this controller is instantiated
                * @memberOf gplans.authentication.controllers.LoginController
                */
    function activate() {
      $rootScope.loginPage = $state.current.loginPage;
      // If the user is authenticated, they should not be here.
      if (Authentication.isAuthenticated()) {
        $state.go('gplans.userConsole');
      }
    }

    /**
      * @name login
      * @desc Log the user in
      * @memberOf gplans.authentication.controllers.LoginController
      */
    function login() {
      vm.loading = true;
      Authentication.login(vm.email, vm.password).then(
      function (res) {
        vm.loading = false;
      }, function (err) {
        vm.loading = false;
        vm.errMessage = err.data.message;
      });
    }
    /**
      * @name fbLogin
      * @desc Log the user in via Facebook connect
      * @memberOf gplans.authentication.controllers.LoginController
      */
    function fbLogin() {
      // $facebook.login().then(function(res){
      //   if(res.status === 'connected') {
      //     Authentication.facebookLogin(res.authResponse.accessToken);
      //   }
      // });
      FB.login(function (res) {
        if (res.status === 'connected') {
          Authentication.facebookLogin(res.authResponse.accessToken);
        }
      }, { scope: 'email' });
    }
  }
})();